// src/components/products/BrandHeader.jsx
import React from "react";

const BrandHeader = ({ selectedBrand, safeText }) => {
  return (
    <div className="flex items-center justify-between mb-4 sm:mb-6">
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
          {safeText(selectedBrand.name)}
        </h2>
        {selectedBrand.subtitle && (
          <p className="mt-1 text-sm sm:text-base text-gray-500">
            {safeText(selectedBrand.subtitle)}
          </p>
        )}
      </div>
      {selectedBrand.logo?.url && (
        <div className="ml-4 flex-shrink-0 flex items-center justify-center">
          <img
            src={selectedBrand.logo?.url}
            alt={safeText(selectedBrand.name)}
            className="h-12 sm:h-14 md:h-16 w-auto object-contain bg-transparent"
          />
        </div>
      )}
    </div>
  );
};

export default BrandHeader;

